import React, { useMemo } from 'react';
import styles from './CaseNumberField.module.scss';
import {
  SFAutocomplete,
  SFAutocompleteProps,
  SFIcon,
  SFMenuOption,
  SFText
} from 'sfui';
import { formatDate } from '../../../../../Helpers';
import { useCaseNumberField } from './Hooks/useCaseNumberField';

export const CaseNumberField = (
  props: SFAutocompleteProps
): React.ReactElement<SFAutocompleteProps> => {
  const { getReportDataForOption, timezone } = useCaseNumberField();

  const renderOption = useMemo(
    () => (option: SFMenuOption) => {
      const reportData = getReportDataForOption(option);
      return (
        <div
          className={styles.caseNumberFieldOption}
          style={{
            padding: option.label && option.label.length > 0 ? '6px 24px' : '0'
          }}
        >
          <SFIcon icon="File-2" size={22} />
          <div className={styles.reportData}>
            <SFText type="component-1">
              {typeof option === 'string' ? option : option.label}
            </SFText>
            {reportData.date && (
              <SFText type="component-3" className={styles.data}>
                {formatDate(reportData.date, 'MM/DD/YYYY - hh:mm', timezone)}
              </SFText>
            )}
            {reportData.fullAddress && (
              <SFText type="component-3" className={styles.data}>
                {reportData.fullAddress}
              </SFText>
            )}
            {reportData.disposition && (
              <SFText type="component-3" className={styles.data}>
                {`${reportData.disposition}`}
              </SFText>
            )}
            {reportData.subjectsCount !== undefined && (
              <SFText type="component-3" className={styles.data}>
                {`${reportData.subjectsCount} ${reportData.subjectsCount === 1 ? 'Subject' : 'Subjects'}`}
              </SFText>
            )}
          </div>
        </div>
      );
    },
    [getReportDataForOption, timezone]
  );

  const value: SFMenuOption | string =
    props.options.find((option) => option.value === props.value) ??
    props.value ??
    '';

  const onChange = (value: string | SFMenuOption) => {
    props.onChange(value);
  };

  const filterOptions = (options: SFMenuOption[]) => {
    return options.filter((option) => {
      const label = option.label;
      return label
        .toLowerCase()
        .includes(
          typeof props.value === 'string'
            ? props.value.toLowerCase()
            : props.value?.label.toLowerCase() || ''
        );
    });
  };

  return (
    <SFAutocomplete
      freeSolo={true}
      label={props.label}
      required={props.required}
      helperText={props.helperText}
      error={props.error}
      options={props.options}
      renderOption={renderOption}
      value={value}
      onChange={onChange}
      filterOptions={filterOptions}
    />
  );
};
